import React from 'react';
import { connect } from 'react-redux';

import {
  getProjectTitle,
  getStackup,
  getCalculations
} from '../../../reducers'
import ExportingDialog from './ExportingDialog';

export const Container = props => (
  <ExportingDialog {...props} />
);

const mapStateToProps = (state) => {
  const title = getProjectTitle(state);
  const stackup = getStackup(state);
  const calculations = getCalculations(state);
  return { calculations, stackup, title };
}

export default connect(mapStateToProps)(Container);



// WEBPACK FOOTER //
// ./src/components/StackupDesign/ExportingDialog/ExportingDialogContainer.jsx